import { render, staticRenderFns } from "./HeaderWeb.vue?vue&type=template&id=3d4f5136&scoped=true&"
import script from "./HeaderWeb.vue?vue&type=script&lang=ts&"
export * from "./HeaderWeb.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderWeb.vue?vue&type=style&index=0&id=3d4f5136&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4f5136",
  null
  
)

export default component.exports